import React, { useEffect, useState } from "react";
import { Button, Flex, Space, Typography } from "antd";
import { MasterConfigs } from "../../../../interfaces/entity";
import './../index.scss';
import CustomTabs from "../../../../components/Tabs";
import FormSetup from "../../../../components/Forms/FormSetup";
import { useDispatch } from "react-redux";
import { postData, putData } from "../../../../actions/developer";
import { getData } from "../../../../actions/apiCall";
import ReusableTable from "../../../../components/TableComponent";
import LeaveSettup from "./LeaveSettup";
const { Title, Text } = Typography

const Configuration = ({ plainId }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [data, setData] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState(plainId)
    const dispatch = useDispatch();

    const tabs = [
        {
            label: 'Configuration',
            key: 'configuration',
            content: 'All content'
        },
        // {
        //     label: 'Employees',
        //     key: 'employees',
        //     content: 'Pending content'
        // },
        // {
        //     label: 'Year End Process',
        //     key: 'endProcess',
        //     content: 'Approved content'
        // },
    ]

    useEffect(() => {
        if (plainId) {
            setSelectedPlan(plainId)
        }
    }, [plainId])

    useEffect(() => {
        getAllLeavsByCategories();
    }, [])

    const getAllLeavsByCategories = async () => {
        const resData = await dispatch(getData('/leave-category/leave-types/category'))
        if (resData.code == 200) {
            setData(resData.data)
        }
    }

    const onSubmit = async (id, values) => {
        const bodyData = {
            leavePlans: values,
            leaveId: plainId
        }
        return new Promise(async (resolve, reject) => {
            if (id) {
                const resData = await dispatch(putData(`/leaves/${id}`, bodyData))
                if (resData.code == 200) {
                    setIsOpen(false)
                    resolve(resData)
                } else {
                    reject(resData)
                }
            } else {
                const resData = await dispatch(postData('/leaves', bodyData))
                if (resData.code == 200) {
                    setIsOpen(false)
                    resolve(resData)
                } else {
                    reject(resData)
                }
            }
        })
    }

    const getAllLeavTypes = () => {
        return data?.map((item) => {
            return {
                label: item?.categoryName,
                name: item?._id,
                type: 'checkboxGroup' as 'checkboxGroup',
                span: 24,
                children: item?.leaves?.map(ele => ({
                    name: ele?.leaveName,
                    value: ele?._id,
                }))
            }
        })
    }

    const formConfig: MasterConfigs = {
        modalTitle: () => 'Leave Plan',
        api: () => `/leaves/${selectedPlan}`,
        combo: [],
        getColumns: () => [
            {
                title: 'Leave',
                dataIndex: '',
                key: '',
                sorter: true,
                width: '20%',
                render: (text) => text?.leaveType?.leaveName
            },
            {
                title: 'Leave Code',
                dataIndex: '',
                key: '',
                sorter: true,
                width: '20%',
                render: (text) => text?.leaveType?.shortCode
            },
            {
                title: 'Available Days',
                dataIndex: 'LeaveYearlyQuota',
                key: 'LeaveYearlyQuota',
                sorter: true,
                width: '20%',
                render: (text) => text?.yearlyQuota
            },
            {
                title: 'Setup',
                dataIndex: '',
                key: '',
                width: '20%',
                render: (text) => <LeaveSettup data={text} />
            }

        ],
        getFormColumns: () => [{
            formItem: () => <Title level={5}>Select the leave types from below to add to the Leave plan</Title>,
            span: 24,
        },
        ...getAllLeavTypes(),
        ],
        onSubmit: (id, values) => onSubmit(id, values)
    }

    const onClose = () => {
        setIsOpen(false)
    }

    const onTabChange = (key: string) => {
        console.log(key)
    }

    return <>
        <FormSetup config={formConfig} open={isOpen} onClose={onClose} isModal={true} />
        <Space direction="vertical" style={{ width: '100%' }} size={[10, 10]}>
            <Flex justify="space-between">
                <CustomTabs
                    tabs={tabs}
                    onTabChange={onTabChange}
                />
                <Button type="primary" onClick={() => setIsOpen(true)}>Add Leaves</Button>
            </Flex>
            <ReusableTable config={formConfig} />
        </Space>
    </>
};

export default Configuration;